import React from 'react';
import { Switch, Route } from 'react-router-dom';
import '../../theme/globalStyles';
import Home from '../Home/Home';

import SkwizDrawingGame from '../SkwizDrawingGame/SkwizDrawingGame';
import SkwizColors from '../SkwizColors/SkwizColors';

import ProgressUI from '../ProgressUI/ProgressUI';
import ProgressComponents from '../ProgressComponents/ProgressComponents';

import MozillaComponentEditor from '../MozillaComponentEditor/ComponentEditor';
import MozillaDesignTokens from '../MozillaDesignTokens/DesignTokens';
import MozillaSketchPlugin from '../MozillaSketchPlugin/SketchPlugin';

import AmazonDesignReviewPlugin from '../AmazonDesignReviewPlugin/DesignReviewPlugin';
import AmazonImportDataPlugin from '../AmazonImportDataPlugin/ImportDataPlugin';

import About from '../About/About';

const App = () => (
      <div className="App">
          <Switch>
            <Route exact path='/' component={Home}/>

            {/*
                <Route path='/skwiz-drawing-game' component={SkwizDrawingGame} />
                <Route path='/skwiz-colors' component={SkwizColors} />
            */}
            
            <Route path='/everyaction-design-system' component={ProgressUI} />
            <Route path='/everyaction-components' component={ProgressComponents} />

            <Route path='/mozilla-component-editor' component={MozillaComponentEditor} />
            <Route path='/mozilla-design-tokens' component={MozillaDesignTokens} />
            <Route path='/mozilla-sketch-plugin' component={MozillaSketchPlugin} />

            <Route path='/amazon-review-plugin' component={AmazonDesignReviewPlugin}/>
            <Route path='/amazon-data-plugin' component={AmazonImportDataPlugin}/>

            <Route path='/about' component={About}/>
          </Switch>
      </div>
    );

export default App;



// WEBPACK FOOTER //
// src/containers/App/App.js